export default {
  state: {
    filters: {
      loading: false,
      departure: {
        date: '',
        return: '',
        isReturning: true,
        show: false
      },
      travellers: {
        show: false,
        total: 1,
        adult: 1,
        children: 0,
        infants: 0,
        info: {
          adult: [],
          children: [],
          infants: []
        },
        forSomeoneElse: false
      },
      airlines: {
        leg1: [],
        leg2: []
      },
      minPrice: 0,
      maxPrice: 40000,
      minPriceReturn: 0,
      maxPriceReturn: 40000,
      refundableOnly: false,
      sort: 'price-low-to-high',
      applyFilter: {
        leg1: {
          Economy: false,
          PremiumEconomy: false,
          Business: false,
          PremiumBusiness: false,
          First: false,
          API2: false
        },
        leg2: {
          Economy: false,
          PremiumEconomy: false,
          Business: false,
          PremiumBusiness: false,
          First: false,
          API2: false
        }
      }
    }
  },
  mutations: {
    setFiltersData (state, data) {
      for (let field in data) {
        state.filters[field] = data[field]
      }
    },
    setDepartureData (state, data) {
      for (let field in data) {
        state.filters.departure[field] = data[field]
      }
    },
    setTravellersData (state, data) {
      for (let field in data) {
        state.filters.travellers[field] = data[field]
      }
    },
    addTravellerInfo (state, data) {
      for (let field in data) {
        state.filters.travellers.info[field] = data[field]
      }
    },
    clearTravellerInfo (state) {
      state.filters.travellers.info = {
        adult: [],
        children: [],
        infants: []
      }
    },
    cleanTravellerInfo (state) {
      state.filters.travellers.info.adult.forEach(pax => {
        for (const key in pax) {
          if (pax.hasOwnProperty(key)) pax[key] = ''
        }
      })
      state.filters.travellers.info.children.forEach(pax => {
        for (const key in pax) {
          if (pax.hasOwnProperty(key)) pax[key] = ''
        }
      })
      state.filters.travellers.info.infants.forEach(pax => {
        for (const key in pax) {
          if (pax.hasOwnProperty(key)) pax[key] = ''
        }
      })
    },
    setApplyFilter (state, data) {
      for (let field in data.fields) {
        state.filters.applyFilter[data.leg][field] = data.fields[field]
      }
    },
    seFiltersAirlinesData (state, data) {
      for (let field in data) {
        state.filters.airlines[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/booking/filters.js